import { render, staticRenderFns } from "./BrokerBankLimits.vue?vue&type=template&id=99bc0422"
import script from "./BrokerBankLimits.vue?vue&type=script&lang=js"
export * from "./BrokerBankLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports